/*global app, routes */
import React from 'react';
import ReactDOM from 'react-dom';
import Player from './Player.js';
import Manager from './Manager.js';
import Synople from './Sdk/Synople.js';
import { withTheme } from '@material-ui/core/styles';
import PropTypes from 'prop-types';
import { MuiThemeProvider, createMuiTheme } from '@material-ui/core/styles';

window.FICHE_PROFIL = '';
window.sdk = new Synople();

// if (window.custom) {
//   window.custom.color.p1 = '#4F8CAF';
//   window.custom.color.p2 = '#ffffff';
//   window.custom.color.p3 = '#4F8CAF';
  
//   window.custom.color.s1 = '#DC150A';
//   window.custom.color.s3 = '#DC150A';
  
//   window.custom.color.back = '#33322E';
//   window.custom.color.txt = '#ffffff';
// }

let theme;
if(window.custom) {
  let palette = {
    primary: {
      main: window.custom.color.p1,
      light: window.custom.color.p2,
      dark: window.custom.color.p3
    },
    secondary: {
      main: window.custom.color.s1,
      light: window.custom.color.s2,
      dark: window.custom.color.s3
    },
    background: {
      paper: (window.custom.color.back) ? window.custom.color.back : '#fff',
      txt: (window.custom.color.txt) ? window.custom.color.txt : '#000',
    }
  }
  
  let themeObj = {
    palette: palette,
    overrides: {
      MuiDivider: {
        light: {
          backgroundColor: palette.primary.light,
          opacity: 0.7
        }
      }
    },
  }
  
  /*
  if(window.custom.synople.typo_name) {
    themeObj.typography = {
      fontFamily: '"' + window.custom.synople.typo_name + '", "Helvetica", "Arial", sans-serif',
    }
  }
 


  if(window.custom.synople.typo_size) {
    themeObj.typography.fontSize = window.custom.synople.typo_size
  }
  */ 
  
  
  theme = createMuiTheme(themeObj);
}
else {
  theme = createMuiTheme();
}




class App extends React.Component {

  updateVH() {
    let vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty('--vh', `${vh}px`);
  }

  componentDidMount() {
    this.updateVH();
    window.addEventListener('resize', this.updateVH);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.updateVH);
  }

  render() {
    return (
      <MuiThemeProvider theme={theme}>
        <T />
        { (window.vod || window.live) && 
          <Player />
        }
        { window.manager &&
          <Manager />
        }
		{ !window.manager &&
			<React.Fragment>
				<div className="borderBottom" style={{ backgroundColor: window.custom.color.p1  }}>
				</div>
				<div className="borderTop" style={{ backgroundColor: window.custom.color.p1  }}>
				</div>
				<div className="borderLeft" style={{ backgroundColor: window.custom.color.p1  }}>
				</div>
				<div className="borderRight" style={{ backgroundColor: window.custom.color.p1  }}>
				</div>
			</React.Fragment>
		}
      </MuiThemeProvider>
    );
  }
  
}


function Truc(props) {
  window.theme = props.theme;
  
  return null
 
  
}

Truc.propTypes = {
  theme: PropTypes.object.isRequired,
};

let T = withTheme()(Truc);


ReactDOM.render(
  <App />,
  document.getElementById('root')
);

//document.getElementById('root').style.border = '1px solid ' + window.custom.color.p1;


// WEBPACK FOOTER //
// ./src/index.js